var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 16H8",
    stroke: "#0A0A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 8H8",
    stroke: "#0A0A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 12H8",
    stroke: "#0A0A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4 3C4 2.73478 4.10536 2.48043 4.29289 2.29289C4.48043 2.10536 4.73478 2 5 2C5.24762 1.99864 5.49048 2.06803 5.7 2.2L6.633 2.8C6.84204 2.93358 7.08493 3.00455 7.333 3.00455C7.58107 3.00455 7.82396 2.93358 8.033 2.8L8.967 2.2C9.17604 2.06642 9.41893 1.99544 9.667 1.99544C9.91507 1.99544 10.158 2.06642 10.367 2.2L11.3 2.8C11.509 2.93358 11.7519 3.00455 12 3.00455C12.2481 3.00455 12.491 2.93358 12.7 2.8L13.633 2.2C13.842 2.06642 14.0849 1.99544 14.333 1.99544C14.5811 1.99544 14.824 2.06642 15.033 2.2L15.967 2.8C16.176 2.93358 16.4189 3.00455 16.667 3.00455C16.9151 3.00455 17.158 2.93358 17.367 2.8L18.3 2.2C18.5095 2.06803 18.7524 1.99864 19 2C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22C18.7524 22.0014 18.5095 21.932 18.3 21.8L17.367 21.2C17.158 21.0664 16.9151 20.9954 16.667 20.9954C16.4189 20.9954 16.176 21.0664 15.967 21.2L15.033 21.8C14.824 21.9336 14.5811 22.0046 14.333 22.0046C14.0849 22.0046 13.842 21.9336 13.633 21.8L12.7 21.2C12.491 21.0664 12.2481 20.9954 12 20.9954C11.7519 20.9954 11.509 21.0664 11.3 21.2L10.367 21.8C10.158 21.9336 9.91507 22.0046 9.667 22.0046C9.41893 22.0046 9.17604 21.9336 8.967 21.8L8.033 21.2C7.82396 21.0664 7.58107 20.9954 7.333 20.9954C7.08493 20.9954 6.84204 21.0664 6.633 21.2L5.7 21.8C5.49048 21.932 5.24762 22.0014 5 22C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V3Z",
    stroke: "#0A0A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceEmptyIcon);
export default __webpack_public_path__ + "static/media/invoice-empty-icon.01dd102cb172675c3153477fb8ecea63.svg";
export { ForwardRef as ReactComponent };